import { render, staticRenderFns } from "./SkvEvent.vue?vue&type=template&id=11b91d74&scoped=true"
import script from "./SkvEvent.vue?vue&type=script&lang=js"
export * from "./SkvEvent.vue?vue&type=script&lang=js"
import style0 from "./SkvEvent.vue?vue&type=style&index=0&id=11b91d74&prod&lang=scss&scoped=true"
import style1 from "./SkvEvent.vue?vue&type=style&index=1&id=11b91d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b91d74",
  null
  
)

export default component.exports